import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversionsAnalyticsListStore } from 'pages/analytics/pages/conversions/store/conversionsAnalyticsListStore'

const ConversionsAnalyticsListContext = createContext<ConversionsAnalyticsListStore | null>(null)

export const useConversionsAnalyticsListContext = () => {
  const context = useContext(ConversionsAnalyticsListContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with ConversionsAnalyticsListProvider'
    )

  return context
}

export const ConversionsAnalyticsListProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ConversionsAnalyticsListStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <ConversionsAnalyticsListContext.Provider value={store}>
      {children}
    </ConversionsAnalyticsListContext.Provider>
  )
}
